import { Vue } from 'vue-property-decorator';

enum Outcome {
  ACCEPTED = 'accepted',
  DISMISSED = 'dismissed',
}

type OutcomeValues = 'accepted' | 'dismissed';

type InstallPromptStore = {
  deferred: BeforeInstallPromptEvent | null;
  outcome: OutcomeValues | null;
  installed: boolean | null;
};

export default class InstallPromptService {
  private static store: InstallPromptStore = Vue.observable({
    deferred: null,
    outcome: null,
    installed: null,
  });

  private static get deferred(): BeforeInstallPromptEvent | null {
    return this.store.deferred;
  }

  private static set deferred(event: BeforeInstallPromptEvent | null) {
    this.store.deferred = event;
  }

  private static set outcome(outcome: OutcomeValues) {
    this.store.outcome = outcome;
  }

  private static set installed(installed: boolean) {
    this.store.installed = installed;
  }

  public static getPromptStore(): InstallPromptStore {
    return this.store;
  }

  public static updateDeferred(event: BeforeInstallPromptEvent | null) {
    this.deferred = event;
  }

  public static updateInstalled(installed: boolean) {
    this.installed = installed;
  }

  public static async promptInstall(): Promise<OutcomeValues | void> {
    if (!this.deferred) {
      return;
    }

    this.deferred.prompt();

    return this.deferred.userChoice
      .then(({ outcome }) => {
        this.outcome = outcome;

        if (outcome === Outcome.ACCEPTED) {
          this.installed = true;
        }

        return outcome;
      })
      .finally(() => {
        this.deferred = null;
      });
  }
}

export { Outcome };
